import {
  useEffect,
} from 'react';

import {
  useRetziaUser,
} from '../hooks/useRetziaUser';
import {
  navigateWithSession,
  replaceWithSession,
} from '../services/sessionNavigation';
import {
  ArrowRightIcon,
  InfoIcon,
} from './retzia/RetziaShellIcons';

const RETZ_URL = 'https://retz.mx';

const LANGUAGES = [
  {
    code: 'EN',
    language: 'english',
    name: 'Inglés',
    description:
      'Practica conversación, escritura y resuelve tus dudas.',
  },
  {
    code: 'DE',
    language: 'german',
    name: 'Alemán',
    description:
      'Refuerza vocabulario, gramática y expresión.',
  },
  {
    code: 'FR',
    language: 'french',
    name: 'Francés',
    description:
      'Practica a tu ritmo y fortalece lo que ves en tu curso.',
  },
];

function Home() {
  const {
    currentUser,
    checking,
  } = useRetziaUser();

  useEffect(() => {
    document.title = 'Elige un idioma | RETZIA';
  }, []);

  useEffect(() => {
    if (!checking && !currentUser) {
      replaceWithSession('/login');
    }
  }, [checking, currentUser]);

  if (checking || !currentUser) {
    return null;
  }

  return (
    <div className="retzia-home" data-retzia-home>
      <header className="retzia-home__top">
        <a
          className="retzia-home__retz-logo"
          href={RETZ_URL}
          target="_top"
          aria-label="Volver a RETZ"
        />
      </header>

      <main className="retzia-home__main">
        <section>
          <div className="retzia-home__hero">
            <span
              className="retzia-home__symbol"
              aria-hidden="true"
            >
              <span className="retzia-home__symbol-mark" />
              <i className="retzia-home__spark" />
            </span>

            <div className="retzia-home__welcome-copy">
              <p className="retzia-home__hello">
                Hola, {currentUser.name} 👋
              </p>

              <h1 className="retzia-home__title">
                ¿Qué idioma quieres practicar hoy?
              </h1>
            </div>
          </div>

          <p className="retzia-home__lead">
            Elige un idioma para comenzar.
          </p>
        </section>

        <section
          className="retzia-home__languages"
          aria-label="Selecciona un idioma"
        >
          {LANGUAGES.map(item => (
            <button
              key={item.language}
              className="retzia-home__language-card"
              type="button"
              data-code={item.code}
              onClick={() =>
                navigateWithSession(
                  `/language?language=${item.language}`
                )
              }
            >
              <span className="retzia-home__language-top">
                <span className="retzia-home__code">
                  {item.code}
                </span>

                <span className="retzia-home__arrow">
                  <ArrowRightIcon />
                </span>
              </span>

              <span className="retzia-home__language-copy">
                <strong className="retzia-home__language-name">
                  {item.name}
                </strong>

                <span className="retzia-home__language-desc">
                  {item.description}
                </span>
              </span>
            </button>
          ))}
        </section>

        <p className="retzia-home__hint">
          <InfoIcon />
          <span>
            Podrás cambiar de idioma en cualquier momento.
          </span>
        </p>
      </main>
    </div>
  );
}

export default Home;
